import React from 'react';
import Icon from '../../../components/AppIcon';
import Select from '../../../components/ui/Select';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';

const TimelineFilters = ({
  selectedWorkOrder = '',
  dateRange = { start: '', end: '' },
  selectedStage = '',
  selectedResponsible = '',
  onWorkOrderChange,
  onDateRangeChange,
  onStageChange,
  onResponsibleChange,
  onClearFilters,
  workOrderOptions = [],
  responsibleOptions = []
}) => {
  const stageOptions = [
    { value: '', label: 'Todas las etapas' },
    { value: 'recepcion', label: 'Recepción' },
    { value: 'inspeccion', label: 'Inspección' },
    { value: 'cotizacion', label: 'Cotización' },
    { value: 'proveedores', label: 'Proveedores' },
    { value: 'aprobado', label: 'Aprobado' },
    { value: 'proceso', label: 'En Proceso' },
    { value: 'terminado', label: 'Terminado' },
    { value: 'entregado', label: 'Entregado' }
  ];

  const hasActiveFilters = selectedWorkOrder || dateRange?.start || dateRange?.end || selectedStage || selectedResponsible;

  return (
    <div className="bg-card rounded-lg border border-border shadow-elevation-2 p-4 md:p-6">
      <div className="flex items-center justify-between gap-4 mb-4 md:mb-6">
        <div className="flex items-center gap-3">
          <div className="p-2 rounded-lg bg-primary/10">
            <Icon name="Filter" size={20} className="text-primary" />
          </div>
          <h2 className="text-lg md:text-xl font-heading font-semibold text-foreground">
            Filtros de Búsqueda
          </h2>
        </div>
        {hasActiveFilters && (
          <Button
            variant="ghost"
            size="sm"
            iconName="X"
            iconPosition="left"
            onClick={onClearFilters}
          >
            Limpiar
          </Button>
        )}
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
        <Select
          label="Orden de Trabajo"
          placeholder="Seleccionar OT"
          options={workOrderOptions}
          value={selectedWorkOrder}
          onChange={onWorkOrderChange}
          searchable
          clearable
        />

        <div className="space-y-3">
          <label className="text-sm font-body font-medium text-foreground">
            Rango de Fechas
          </label>
          <div className="grid grid-cols-2 gap-3">
            <Input
              type="date"
              placeholder="Fecha inicio"
              value={dateRange?.start}
              onChange={(e) => onDateRangeChange({ ...dateRange, start: e?.target?.value })}
            />
            <Input
              type="date"
              placeholder="Fecha fin"
              value={dateRange?.end}
              onChange={(e) => onDateRangeChange({ ...dateRange, end: e?.target?.value })}
            />
          </div>
        </div>

        <Select
          label="Etapa del Proceso"
          placeholder="Todas las etapas"
          options={stageOptions}
          value={selectedStage}
          onChange={onStageChange}
          clearable
        />

        <Select
          label="Responsable"
          placeholder="Todos los responsables"
          options={responsibleOptions}
          value={selectedResponsible}
          onChange={onResponsibleChange}
          searchable
          clearable
        />

        <div className="flex items-end">
          <Button
            variant="default"
            iconName="Search"
            iconPosition="left"
            fullWidth
          >
            Buscar
          </Button>
        </div>
      </div>
      {hasActiveFilters && (
        <div className="mt-4 pt-4 border-t border-border">
          <div className="flex flex-wrap items-center gap-2">
            <span className="text-sm caption text-muted-foreground">Filtros activos:</span>
            {selectedWorkOrder && (
              <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-md bg-primary/10 text-primary text-sm">
                <span>OT: {selectedWorkOrder}</span>
                <button
                  onClick={() => onWorkOrderChange('')}
                  className="hover:bg-primary/20 rounded p-0.5 transition-smooth"
                >
                  <Icon name="X" size={14} />
                </button>
              </div>
            )}
            {(dateRange?.start || dateRange?.end) && (
              <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-md bg-accent/10 text-accent text-sm">
                <span>
                  {dateRange?.start && dateRange?.end
                    ? `${dateRange?.start} - ${dateRange?.end}`
                    : dateRange?.start || dateRange?.end}
                </span>
                <button
                  onClick={() => onDateRangeChange({ start: '', end: '' })}
                  className="hover:bg-accent/20 rounded p-0.5 transition-smooth"
                >
                  <Icon name="X" size={14} />
                </button>
              </div>
            )}
            {selectedStage && (
              <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-md bg-secondary/10 text-secondary text-sm">
                <span>{stageOptions?.find(s => s?.value === selectedStage)?.label}</span>
                <button
                  onClick={() => onStageChange('')}
                  className="hover:bg-secondary/20 rounded p-0.5 transition-smooth"
                >
                  <Icon name="X" size={14} />
                </button>
              </div>
            )}
            {selectedResponsible && (
              <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-md bg-warning/10 text-warning text-sm">
                <span>{responsibleOptions?.find(r => r?.value === selectedResponsible)?.label}</span>
                <button
                  onClick={() => onResponsibleChange('')}
                  className="hover:bg-warning/20 rounded p-0.5 transition-smooth"
                >
                  <Icon name="X" size={14} />
                </button>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default TimelineFilters;